export default __webpack_public_path__ + "static/media/_094.88ecfeba.jpg";